// eslint-disable-next-line no-restricted-imports
import { BoxProps, Box as MuiBox } from '@mui/material';

type Props = BoxProps;

export const Box = ({ children, ...boxProps }: Props) => {
  return <MuiBox {...boxProps}>{children}</MuiBox>;
};
